import { CancelarOrdem, CopyOrdem, ViewCancelForm } from '@actions/novaOrdemActions';
import { useAppDispatch, useAppSelector } from '@config/reduxStore';
import { Form, Input, Modal } from 'antd';

type FormData = {
  motivo: string;
};

function CancelOrdemModalRedux() {
  const dispatch = useAppDispatch();
  const { cancelingOrdem, cancelForm } = useAppSelector((state) => state.novaOrdem);
  const [form] = Form.useForm<FormData>();
  const handleSubmit = (values: FormData) => {
    if (cancelForm.replace) {
      dispatch(CopyOrdem({ id: cancelForm.id, motivo: values.motivo, replaced: true }));
    } else dispatch(CancelarOrdem({ id: cancelForm.id, motivo: values.motivo, cod: cancelForm.cod }));
  };
  return (
    <Modal
      open={cancelForm.visible}
      title="Razão do cancelamento/substituição"
      onCancel={() => {
        dispatch(ViewCancelForm({ id: null, view: false, replace: false, cod: null }));
      }}
      okButtonProps={{ loading: cancelingOrdem }}
      onOk={() => form.submit()}
    >
      <Form form={form} onFinish={handleSubmit}>
        <Form.Item rules={[{ required: true, message: 'Campo obrigatório' }]} name="motivo">
          <Input.TextArea />
        </Form.Item>
      </Form>
    </Modal>
  );
}
export default CancelOrdemModalRedux;
